import {Pipe, PipeTransform} from '@angular/core';
import {LoggerService} from '../../hbs-services';

@Pipe({
    name: 'timeLimit'
})
export class TimeLimitPipe implements PipeTransform {

    constructor(private logger: LoggerService) {
    }

    transform(value: any, args: any[]): any {
        let ret = value;
        if (value.timeLimit <= 0) {
            ret = null;
        }
        this.logger.log('TimeLimitPipe', ret);
        return ret;
    }
}
